export const INPUT_PANEL_EN = {
  inputTool: 'Input Options',
  fileUploadTooltip: 'Upload file',
  libraryTooltip: 'Library',
  contentTooltip: 'Content Database',
  newsboxTooltip: 'Newsbox',
  scraperTooltip: 'Url Scraper',
  webSearchTooltip: 'Web Search'
}

export const INPUT_PANEL_DE = {
  inputTool: 'Eingabe Options',
  fileUploadTooltip: 'Datei hochladen',
  libraryTooltip: 'Archiv',
  contentTooltip: 'Content-Datenbank',
  newsboxTooltip: 'Newsbox',
  scraperTooltip: 'URL-Scraper',
  webSearchTooltip: 'Web-Suche'
}
